import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function UnlockYourInvestmentPotential() {
  return <section className="relative min-h-[80vh] flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/wall_street_bull_bronze_statue.png)]">
      {}
      <div className="absolute inset-0 bg-black bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/stock_market_candlestick_chart_overlay.png)] opacity-40" />
      
      {}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="animate-fade-in-up">
          <h1 className="text-5xl lg:text-6xl font-semibold text-white leading-tight mb-6">
            Desbloquea Tu Potencial de Inversión
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Zafiro Investments empodera a los estudiantes para dominar la bolsa de valores estadounidense a través de cursos dirigidos por expertos y estrategias prácticas del mundo real.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/ContactoPage">
              <Button size="lg" variant="outline" className="bg-white/10 backdrop-blur-sm text-white border-yellow-400 hover:bg-white/20 hover:border-yellow-500 animate-pulse hover:animate-none font-bold" style={{
              animation: 'pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            }}>
                Comienza Hoy
              </Button>
            </Link>
            <Link to="/CursosPage">
              <Button size="lg" className="btn-primary group">
                Explora Nuestros Cursos
                <ArrowRight className="ml-2 transition-transform duration-[var(--duration-medium)] group-hover:translate-x-1" />
              </Button>
            </Link>
            <Link to="/ContactoPage">
              <Button size="lg" className="bg-secondary text-white hover:bg-secondary-hover transition-all duration-[var(--duration-medium)]">
                <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                Webinar
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}